<section>
    <div class="title_block">
        <a class="cursor-pointer" routerLink="/app/dashboard">
            <img src="assets/images/navigation/back-arrow.png" alt="icon" class="img-responsive">
        </a>
        <h4>Project Management</h4>
    </div>
</section>
<div>
    <pms-integrator [projectID]="projectId" [requester]="userId"></pms-integrator>
</div>